import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: ${theme.white};
    margin-bottom: 20px;
    border-radius: 8px;
    height: 73px;
    width: calc(100% - 60px);
    padding: 0 10px;

    div:nth-child(1) {
        display: flex;
        align-items: center;

        label {
            font-size: 12px;
            font-weight: 400;
            color: ${theme.textDark};
            margin-left: 10px;
        }
    }

    div:nth-child(2) {
        margin-top: 2px;

        span {
            font-size: 28px;
            font-weight: 700;
            color: ${theme.textDark};
        }

        label {
            font-size: 11px;
            font-weight: 400;
            margin-left: 10px;
            color: ${theme.textDark};
        }
    }
`;

export { Container };